<template>
  <div class="user_info_container_meun">
    <el-menu
    class="el-menu-vertical-demo"
    @select="handleSelect"
    :router = 'true'
    :default-active = meunActive
    :unique-opened = 'true'
    >
      <div class="user_info_menu_item" v-for="(item, index) in meunList" :key="item.id" >
        <div v-if="item.children.length > 0">
          <el-submenu :index="item.index">
            <template slot="title">
              <div class="my_personal_menu_title">
                <i :class="hoverIndex === index ? item.hoverIcon : item.icon"></i>
                <span>{{item.name}}</span>
              </div>
            </template>
            <el-menu-item-group v-if="item.children.length > 0">
              <el-menu-item v-for="(son,n) in item.children" :key="n" :route = "{ name: (son.to + '') }" :index="son.index" style="padding-left:48px">{{son.name}}</el-menu-item>
            </el-menu-item-group>
          </el-submenu>
        </div>
        <div v-else>
          <el-menu-item :index="item.index" :route = "{ name: (item.to + '') }">
            <div class="my_personal_menu_title">
              <i :class="hoverIndex === index ? item.hoverIcon : item.icon"></i>
              <span slot="title">{{item.name}}</span>
            </div>
          </el-menu-item>
        </div>
      </div>
    </el-menu>
  </div>
</template>

<script>
export default {
  name: 'meun',
  props: {
    slid: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      // 记录鼠标划过的导航下标
      hoverIndex: '',
      // 导航列表
      meunList: [
        {
          name: '动态',
          icon: 'personal_icon dongtai',
          hoverIcon: 'personal_icon personal_icon_hover dongtai',
          index: 'dynamic',
          to: '',
          children: [
            { name: '我的动态', to: 'MyDynamic', index: 'myDynamic' },
            { name: '关于我的', to: 'AboutDynamic', index: 'aboutDynamic' }
          ]
        },
        {
          name: '发布管理',
          icon: 'personal_icon fabu',
          hoverIcon: 'personal_icon personal_icon_hover fabu',
          index: 'admin',
          children: [
            { name: '直播列表', to: 'LiveList', index: 'liveList' },
            { name: '文章列表', to: 'ArticleList', index: 'articleList' },
            { name: '视频列表', to: 'UserVideoList', index: 'videoList' },
            // { name: '培训列表', to: 'TrainList', index: 'trainList' },
            { name: '草稿箱', to: 'DraftList', index: 'draftList' }
          ]
        },
        {
          name: '我的关注',
          icon: 'personal_icon guanzhu',
          hoverIcon: 'personal_icon personal_icon_hover guanzhu',
          index: 'follow',
          children: [
            { name: '我的关注', to: 'FollowList', index: 'followList' },
            { name: '我的粉丝', to: 'FansList', index: 'fansList' }
          ]
        },
        // {
        //   name: '我的联盟',
        //   icon: 'personal_icon shoucang',
        //   hoverIcon: 'personal_icon personal_icon_hover shoucang',
        //   index: 'myUnion',
        //   to: 'MyUnion',
        //   children: []
        // },
        // {
        //   name: '我的研究院',
        //   icon: 'personal_icon shoucang',
        //   hoverIcon: 'personal_icon personal_icon_hover shoucang',
        //   index: 'myResearch',
        //   to: 'MyResearch',
        //   children: []
        // },
        {
          name: '我的收藏',
          icon: 'personal_icon shoucang',
          hoverIcon: 'personal_icon personal_icon_hover shoucang',
          index: 'collect',
          to: 'CollectList',
          children: []
        },
        {
          name: '我的评论',
          icon: 'personal_icon pinglun',
          hoverIcon: 'personal_icon personal_icon_hover pinglun',
          index: 'commentList',
          to: 'CommentList',
          children: []
        },
        {
          name: '我的圈子',
          icon: 'personal_icon quanzi',
          hoverIcon: 'personal_icon personal_icon_hover quanzi',
          index: 'myCircle',
          children: [
            { name: '我的圈子', to: 'MyCircleList', index: 'myCircleList' },
            { name: '加入的圈子', to: 'JoinCircleList', index: 'joinCircleList' }
          ]
        },
        {
          name: '认证系统',
          icon: 'personal_icon renzheng',
          hoverIcon: 'personal_icon personal_icon_hover renzheng',
          index: 'certification',
          children: [
            { name: '实名认证', to: 'PersonalCertification', index: 'personalCertification' },
            { name: '播主认证', to: 'AnchorCertification', index: 'anchorCertification' },
            { name: '律师认证', to: 'LawyerCertification', index: 'lawyerCertification' },
            { name: '企业认证', to: 'CompanyCertification', index: 'companyCertification' }
          ]
        },
        {
          name: '账号设置',
          icon: 'personal_icon anquan',
          hoverIcon: 'personal_icon personal_icon_hover anquan',
          index: 'account',
          children: [
            { name: '个人资料', to: 'PersonalData', index: 'personalData' },
            { name: '账号管理', to: 'AccountSecurity', index: 'accountSecurity' }
          ]
        }
      ],
      // 默认选中栏
      meunActive: ''
    }
  },
  created () {
    this.meunActive = this.$store.state.personalMeunAct
  },
  computed: {
    getMeunActive () {
      return this.$store.state.personalMeunAct // 需要监听的数据
    }
  },
  watch: {
    sild: {
      handle: function (val, oldVal) {
        this.$store.commit('editPersonalMeunAct', val)
      }
    },
    getMeunActive (val, oldVal) {
      this.meunActive = val
    }
  },
  methods: {
    // 点击修改导航栏选中项
    handleSelect (index) {
      this.$store.commit('editPersonalMeunAct', index)
    }
  }
}
</script>

<style>
</style>
